import { render, staticRenderFns } from "./Ghabz.vue?vue&type=template&id=39b926e8&scoped=true&"
import script from "./Ghabz.vue?vue&type=script&lang=js&"
export * from "./Ghabz.vue?vue&type=script&lang=js&"
import style0 from "./Ghabz.vue?vue&type=style&index=0&id=39b926e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b926e8",
  null
  
)

export default component.exports